import gql from 'graphql-tag';

export default gql`
  fragment addressFragment on AddressType {
    id
    orderId
    userId
    industryTypeId
    firstName
    lastName
    gender
    genderText
    birthdayYear
    birthdayMonth
    birthdayDay
    tel
    zipcode
    address1
    address2
    companyName
    companyNameKana
    companyBranchName
    companyPosition
    companyTel
    companyFax
  }
`;
